<div class="w-[950px]">
  <ng-template #errorTemplate let-error let-refresh="refresh">
    <rxap-data-source-error [error]="error" [refresh]="refresh"></rxap-data-source-error>
  </ng-template>
  <div class="flex flex-col gap-y-4">
    @if (accordionDataSource.loading$ | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    <mat-accordion *rxapDataSource="let data from accordionDataSource; errorTemplate: errorTemplate" [rxapPersistentAccordion]="data.uuid">

      <mat-expansion-panel expanded>

        <mat-expansion-panel-header>
          <mat-panel-title i18n>Account information</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <eurogard-user-account-information></eurogard-user-account-information>
        </ng-template>

      </mat-expansion-panel>

      <mat-expansion-panel>

        <mat-expansion-panel-header>
          <mat-panel-title>
            <ng-container i18n>Multi-Factor Authentication</ng-container>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          @if (accordionDataSource.user()?.uuid) {
            <eurogard-user-mfa-settings [userUuid]="accordionDataSource.user()!.uuid!"></eurogard-user-mfa-settings>
          }
        </ng-template>

      </mat-expansion-panel>

      <mat-expansion-panel>

        <mat-expansion-panel-header>
          <mat-panel-title i18n>Notification settings</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <eurogard-alarming-settings-panel [enforceCompactDesign]="true"></eurogard-alarming-settings-panel>
        </ng-template>

      </mat-expansion-panel>


      <mat-expansion-panel>

        <mat-expansion-panel-header>
          <mat-panel-title i18n>Subscribed Machines for notifications</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <eurogard-subscribed-machines-panel [userUuid]="accordionDataSource.user()?.uuid"></eurogard-subscribed-machines-panel>
        </ng-template>

      </mat-expansion-panel>

      <mat-expansion-panel>

        <mat-expansion-panel-header>
          <mat-panel-title i18n>Subscribed Routers for notifications</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <eurogard-subscribed-routers-panel [userUuid]="accordionDataSource.user()?.uuid"></eurogard-subscribed-routers-panel>
        </ng-template>

      </mat-expansion-panel>

      @if (hasPermissionDeviceInboxToken) {
        <mat-expansion-panel>

          <mat-expansion-panel-header>
            <mat-panel-title>
              <ng-container i18n>Inbox Registration Token</ng-container>
              <eurogard-feature-text-text class="ml-2" featureInfoType="new"></eurogard-feature-text-text>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <eurogard-registration-token-form></eurogard-registration-token-form>
          </ng-template>

        </mat-expansion-panel>
      }

    </mat-accordion>
  </div>

</div>
